
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-white px-8"
      style={{ fontFamily: 'Noto Sans KR, sans-serif' }}
    >
      <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mb-6">
        <i className="ri-leaf-line text-3xl text-emerald-600 w-8 h-8 flex items-center justify-center"></i>
      </div>
      <h2
        className="text-2xl font-bold text-gray-900 mb-3"
        style={{ fontFamily: 'Noto Serif KR, serif' }}
      >
        페이지를 찾을 수 없습니다
      </h2>
      <p className="text-sm text-gray-500 mb-8">
        요청하신 페이지가 존재하지 않거나 이동되었습니다.
      </p>
      <Link
        to="/"
        className="px-8 py-3 bg-emerald-600 text-white rounded-full text-sm font-semibold hover:bg-emerald-700 transition-all whitespace-nowrap cursor-pointer"
      >
        홈으로 돌아가기
      </Link>
    </div>
  );
}
